module.exports = __webpack_public_path__ + "static/media/view test info dept.07c7fbc1.svg";